module.exports = __webpack_public_path__ + "img/manufacture.9550767.webp";